var _title, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgWallet = function SvgWallet(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 17 18",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "wallet")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.1-Home",
    transform: "translate(-36.000000, -216.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wallet",
    transform: "translate(32.000000, 213.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5.000000, 4.000000)",
    stroke: "#000000de",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 3.07872068,
    width: 15,
    height: 12.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.86158354,1.51883258 C3.48743985,1.51883258 6.20595214,1.49748202 10.0171204,1.45478088 C10.7567106,1.45478088 11.3562668,2.05433716 11.3562668,2.7939273 C11.3562668,3.6802326 11.3562668,4.34496157 11.3562668,4.78811422",
    id: "Path",
    transform: "translate(6.608925, 3.121448) rotate(-19.000000) translate(-6.608925, -3.121448) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,10.612054 C15,11.0538818 14.6418278,11.412054 14.2,11.412054 L11.8,11.412054 C11.3581722,11.412054 11,11.0538818 11,10.612054 L11,8.21205401 C11,7.77022621 11.3581722,7.41205401 11.8,7.41205401 L14.2,7.41205401 C14.6418278,7.41205401 15,7.77022621 15,8.21205401",
    id: "Path"
  })))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWallet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wallet.02c6cfa2.svg";
export { ForwardRef as ReactComponent };